"use client";

import { MegaMenuDesktop } from "../MegaMenuDesktop/MegaMenuDesktop";
import { MegaMenuResponsive } from "../MegaMenuResponsive/MegaMenuResponsive";
import type { IMegaMenuStandardProps } from "./MegaMenuStandard.props";

export const MegaMenuStandard = ({ actions, items, logo, sticky }: IMegaMenuStandardProps) => (
  <>
    <MegaMenuDesktop
      actions={actions}
      className="hidden lg:block"
      items={items}
      logo={logo}
      sticky={sticky}
    />
    <MegaMenuResponsive
      actions={actions}
      className="lg:hidden"
      items={items}
      logo={logo}
      sticky={sticky}
    />
  </>
);

MegaMenuStandard.displayName = "MegaMenu::MegaMenuStandard";
